/**
 * Wallet-account precheck used historically to query an external user service (legacy; prefer wallet-first flows).
 * MPRO Lab is standalone and no longer performs this lookup — we return a permissive shape that
 * keeps the legacy UI happy (wallet is treated as a known, verified account).
 */
export interface WalletAccountPrecheck {
  hasAccount: boolean
  hasExternalAccount: boolean
  rulesCheckbox: boolean
}

export const fetchWalletAccountCheck = async (
  _account: string,
  _options?: { externalAccountType?: string }
): Promise<WalletAccountPrecheck> => {
  return {
    hasAccount: true,
    hasExternalAccount: false,
    rulesCheckbox: true,
  }
}

export default fetchWalletAccountCheck
